"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.notifcationSubType = exports.WebhookType = exports.WebhookTypeIterable = exports.EmailType = exports.CapitalProviderEmailType = exports.CapitalProviderEmailTypeIterable = exports.BorrowerSlackNotificationType = exports.BorrowerSlackNotificationTypeIterable = exports.BorrowerSlackTypeDEPRECATED = exports.BorrowerSlackTypeDEPRECATEDIterable = exports.BorrowerEmailType = exports.BorrowerEmailTypeIterable = exports.SlackGroups = exports.SlackGroupsIterable = void 0;
exports.SlackGroupsIterable = ['capMarkets'];
exports.SlackGroups = {
    CapMarkets: 'capMarkets',
};
exports.BorrowerEmailTypeIterable = [
    'assignmentEmail',
    'digestEmail',
    'fundingRequestEmail',
    'fundingRequestSubmittedBorrowerEmail',
    'fundingRequestSubmittedCapitalProviderEmail',
    'fundingRequestApproval',
    'upcomingDeliverableEmail',
    'deliverablesDueSoon',
    'deliverablesNewComment',
    'deliverablesReportLenderReviewResult',
    'deliverablesReportGeneratedResult',
    'deliverablesResponsiblePartyReminder',
    'deliverablesResponsiblePartySubmitSubmission',
    'deliverablesResponsiblePartyStatusUpdate',
    'servicerReportPreviewEmail',
    'servicerReportFailureEmail',
    'dataTapeIngestionErrors',
    'borrowingBaseReportGenerated',
    'masterTrustPortfolioOverview',
    'metricAlert',
    'remediationRequestedBorrowerAction',
    'verificationReportAdjudicationAction',
    'verificationReportCreatedBorrower',
    'verificationReportReadyForReviewBorrower',
    'invoiceCalculationComparison',
    'successfulIbsTransactionIngest',
];
exports.BorrowerEmailType = {
    assignmentEmail: 'assignmentEmail',
    digestEmail: 'digestEmail',
    fundingRequestEmail: 'fundingRequestEmail', // automatically generated target funding request email + funding request expired email
    fundingRequestSubmittedBorrowerEmail: 'fundingRequestSubmittedBorrowerEmail', // the receipt and packet emails for borrowers
    fundingRequestSubmittedCapitalProviderEmail: 'fundingRequestSubmittedCapitalProviderEmail', // the direct captial provider approval email
    fundingRequestApproval: 'fundingRequestApproval', // email when capital provider approves a funding request submitted by the borrower via the normal borrower submission flow
    upcomingDeliverableEmail: 'upcomingDeliverableEmail',
    // v4 deliverables
    deliverablesDueSoon: 'deliverablesDueSoon',
    deliverablesNewComment: 'deliverablesNewComment',
    deliverablesReportLenderReviewResult: 'deliverablesReportLenderReviewResult',
    deliverablesReportGeneratedResult: 'deliverablesReportGeneratedResult',
    // @jendevelops this is not really a borrower only email type, but will leave here for now
    deliverablesResponsiblePartyReminder: 'deliverablesResponsiblePartyReminder',
    deliverablesResponsiblePartySubmitSubmission: 'deliverablesResponsiblePartySubmitSubmission',
    deliverablesResponsiblePartyStatusUpdate: 'deliverablesResponsiblePartyStatusUpdate',
    servicerReportPreviewEmail: 'servicerReportPreviewEmail',
    servicerReportFailureEmail: 'servicerReportFailureEmail',
    dataTapeIngestionErrors: 'dataTapeIngestionErrors',
    borrowingBaseReportGenerated: 'borrowingBaseReportGenerated', // sent when a borrowing base report is generated. may include servicer report
    masterTrustPortfolioOverview: 'masterTrustPortfolioOverview',
    metricAlert: 'metricAlert',
    remediationRequestedBorrowerAction: 'remediationRequestedBorrowerAction', // sent to borrower when capital provider requests calc verification remediation from borrower
    verificationReportAdjudicationAction: 'verificationReportAdjudicationAction', // sent to borrower and capital provider when a capital provider approves or denies a calc verification report
    verificationReportCreatedBorrower: 'verificationReportCreatedBorrower', // sent to borrower when a verification report has been created from a servicer report upload
    verificationReportReadyForReviewBorrower: 'verificationReportReadyForReviewBorrower', // sent to borrower when a verification report has been created from a servicer report upload
    invoiceCalculationComparison: 'invoiceCalculationComparison', // sent to user when an invoice is created with mismatches between input and Finley calculations
    successfulIbsTransactionIngest: 'successfulIbsTransactionIngest', // sent to user when IBS transaction ingestion is completely successful
};
exports.BorrowerSlackTypeDEPRECATEDIterable = [
    'updateDeliverableStatusDueSoon',
    'updateDeliverableStatusOverdue',
    'UpdateDeliverableStatusCompleted',
    'targetFundingRequest',
    'fundingRequestPostSubmit',
    'fundingRequestExpire',
];
exports.BorrowerSlackTypeDEPRECATED = {
    UpdateDeliverableStatusDueSoon: 'updateDeliverableStatusDueSoon',
    UpdateDeliverableStatusOverdue: 'updateDeliverableStatusOverdue',
    UpdateDeliverableStatusCompleted: 'UpdateDeliverableStatusCompleted',
    TargetFundingRequest: 'targetFundingRequest',
    FundingRequestPostSubmit: 'fundingRequestPostSubmit',
    FundingRequestExpire: 'fundingRequestExpire',
};
exports.BorrowerSlackNotificationTypeIterable = [
    'dataTapeIngestionErrors',
    'metricAlert',
    'deliverablesResponsiblePartyReminder',
    'deliverablesResponsiblePartySubmitSubmission',
    'deliverablesResponsiblePartyStatusUpdate',
    'fundingRequestApproval',
    'fundingRequestAutoGenerated',
    'fundingRequestExpired',
    'fundingRequestPostSubmit',
    'deliverableStatusUpdate',
    'workflowGenericNotifyApproval',
];
exports.BorrowerSlackNotificationType = {
    dataTapeIngestionError: 'dataTapeIngestionErrors',
    metricAlert: 'metricAlert',
    // @jendevelops this is not really a borrower only slack type, but will leave here for now
    deliverablesResponsiblePartyReminder: 'deliverablesResponsiblePartyReminder',
    deliverablesResponsiblePartySubmitSubmission: 'deliverablesResponsiblePartySubmitSubmission',
    deliverablesResponsiblePartyStatusUpdate: 'deliverablesResponsiblePartyStatusUpdate',
    fundingRequestApproval: 'fundingRequestApproval',
    fundingRequestAutoGenerated: 'fundingRequestAutoGenerated',
    fundingRequestExpired: 'fundingRequestExpired',
    fundingRequestPostSubmit: 'fundingRequestPostSubmit',
    // old deliverables stuff (deprecated)
    deliverableStatusUpdate: 'deliverableStatusUpdate',
    // workflow generic emails
    workflowGenericNotifyApproval: 'workflowGenericNotifyApproval',
};
exports.CapitalProviderEmailTypeIterable = [
    'receivablesSaleAgreementGenerated',
    'fundingRequestSubmittedCapitalProviderEmail',
    'fundingRequestApproval',
    'borrowingBaseReportGenerated',
    'dataTapeIngestionErrors',
    'remediationRequestedCapitalProviderReceipt',
    'verificationReportAdjudicationAction',
    'verificationReportReadyForReviewCapitalProvider',
    'deliverablesNewComment',
    'deliverablesReportReadyForReview',
    'workflowGenericNotifyApproval',
    'missingPipelineInputs',
    'invoiceCalculationComparison',
    'successfulIbsTransactionIngest',
];
exports.CapitalProviderEmailType = {
    receivablesSaleAgreementGenerated: 'receivablesSaleAgreementGenerated', // sent when a receivables sale agreement is generated
    fundingRequestSubmittedCapitalProviderEmail: 'fundingRequestSubmittedCapitalProviderEmail', // the direct capital provider approval email
    fundingRequestApproval: 'fundingRequestApproval', // email when capital provider approves a funding request submitted by the borrower via the normal borrower submission flow
    borrowingBaseReportGenerated: 'borrowingBaseReportGenerated', // sent when a borrowing base report is generated. may include servicer report
    dataTapeIngestionErrors: 'dataTapeIngestionErrors',
    remediationRequestedCapitalProviderReceipt: 'remediationRequestedCapitalProviderReceipt', // sent to capital provider when they request calc verification remediation from borrower
    verificationReportAdjudicationAction: 'verificationReportAdjudicationAction', // sent to borrower and capital provider when a capital provider approves or denies a calc verification report
    verificationReportReadyForReviewCapitalProvider: 'verificationReportReadyForReviewCapitalProvider', // sent to capital provider when a verification report has been created from a servicer report upload
    // v4 deliverables
    deliverablesNewComment: 'deliverablesNewComment',
    deliverablesReportReadyForReview: 'deliverablesReportReadyForReview',
    // workflow generic emails
    workflowGenericNotifyApproval: 'workflowGenericNotifyApproval',
    missingPipelineInputs: 'missingPipelineInputs',
    invoiceCalculationComparison: 'invoiceCalculationComparison', // sent to user when an invoice is created with mismatches between input and Finley calculations
    successfulIbsTransactionIngest: 'successfulIbsTransactionIngest', // sent to user when IBS transaction ingestion is completely successful
};
exports.EmailType = {
    ...exports.BorrowerEmailType,
    ...exports.CapitalProviderEmailType,
};
exports.WebhookTypeIterable = [
    'fundingRequestApprovedWebhook',
    'borrowingBaseReportGeneratedWebhook',
    'assignmentAssignEventWebhook',
];
exports.WebhookType = {
    fundingRequestApprovedWebhook: 'fundingRequestApprovedWebhook',
    borrowingBaseReportGeneratedWebhook: 'borrowingBaseReportGeneratedWebhook',
    assignmentAssignEventWebhook: 'assignmentAssignEventWebhook',
};
exports.notifcationSubType = {
    ...exports.BorrowerEmailType,
    ...exports.CapitalProviderEmailType,
    ...exports.WebhookType,
};
//# sourceMappingURL=common.js.map